// extracted by mini-css-extract-plugin
export default {"dark":"InviteUser_dark__McKfG","App":"InviteUser_App__kjuwf","formInvite":"InviteUser_formInvite__AqLvN","containerCheckOwnerMail":"InviteUser_containerCheckOwnerMail__xfB7U"};